export function debounce<F extends (...args: any[]) => void>(fn: F, ms: number): F {
  let timeout: number;
  return function debounced(...args: any[]) {
    window.clearTimeout(timeout);
    timeout = window.setTimeout(() => fn(...args), ms);
  } as F;
}
